module.exports = __webpack_public_path__ + "img/3d.02ee3652.gif";